import DOMPurify from 'dompurify'

export const stripHTML = (html = '') => {
  const element = document.createElement('div')
  element.innerHTML = DOMPurify.sanitize(html, { USE_PROFILES: { html: true } })

  return element.textContent
}
